export default {
  "content": "<path opacity=\".3\" d=\"M81 .52C41-1.68 13.94 33.8 4.46 68.89c-5 18.52-6.35 39.1.57 57.33 6 15.69 17.56 28.22 31.92 36.7 29.78 17.57 73 20.55 102.06.18 29.06-20.37 41.29-57.08 32.06-91.09C159.78 30.42 121.15 3.53 79.16.61c-6-.42-5.93 8.87 0 9.28 33 2.33 64.07 21.06 78.21 51.48 13.51 29 8.6 64-14.54 86.64-23.56 23-60.66 24.37-90 12.47-13.28-5.37-25.65-14.19-33.49-26.34-9.39-14.63-11.3-32.53-8.76-49.47C15.95 49.1 39.95 7.55 81 9.8c6 .33 6-9 0-9.28z\" fill=\"#8CA3FF\"/>",
  "attrs": {
    "width": "175",
    "height": "69",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};